<template>
  <q-table
    class="q-pa-md"
    :title="title"
    :data="data"
    :columns="columns"
    :pagination="{ page: 1, rowsPerPage: 0 }"
    hide-bottom
  >
    <template v-slot:body-cell="props">
      <q-td :props="props">
        {{ props.value }}
        <LmTooltip> {{ props.value }} </LmTooltip>
      </q-td>
    </template>
  </q-table>
</template>

<script>
export default {
  props: {
    data: Array,
    columns: Array,
    title: String
  }
}
</script>

<style lang="stylus" scoped>
>>> .q-table {
  td {
    overflow hidden
    text-overflow ellipsis
    max-width 0
  }
}
</style>
